import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Grid, Box, Button } from "@material-ui/core";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnUtils from "@date-io/date-fns"
import api from "../../api/api";
import Loader from "../../components/Loader";

import ActivityLogTable from "../../components/tables/ActivityLogTable";
import { GridSearchIcon } from "@mui/x-data-grid";

function ActivityLog({ data, handleShowLogs }) {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const today = new Date();
  const twoWeeksAgo = new Date();
  twoWeeksAgo.setDate(today.getDate() - 15);
  const [startDate, setStartDate] = React.useState(twoWeeksAgo);
  const [endDate, setEndDate] = React.useState(today);

  const auth = useSelector((state) => state.authReducer);

  useEffect(() => {
    getActivityLogs();
  }, []);

  const getActivityLogs = () => {
    setIsLoading(true);
    api
      .get(
        `api/ActivityLog/${data?.applicationVersionId}/${data?.id}/List?v=1.0&startDate=${startDate.toISOString().slice(0,10)}&endDate=${endDate.toISOString().slice(0,10)}`,

        {
          headers: {
            Authorization: `Bearer ${auth.user?.token}`,
          },
        }
      )
      .then((response) => {
        if (response.status === 200) {
          setLogs(response.data.data);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setError(error.message);
      });
  };

  if (error) return <div style={{ color: "red" }}>{error}</div>;
  return (
    <>
      {isLoading && <Loader />}
      {!isLoading && (
        <MuiPickersUtilsProvider utils={DateFnUtils}>
          <Box mb={2} style={{ width: "100%" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item>
                <KeyboardDatePicker
                  margin="normal"
                  label="Start Date"
                  format="yyyy-MM-dd"
                  value={startDate}
                  onChange={setStartDate}
                  KeyboardButtonProps={{ "aria-label": "change date" }}
                />
              </Grid>
              <Grid item>
                <KeyboardDatePicker
                  margin="normal"
                  label="End Date"
                  format="yyyy-MM-dd"
                  value={endDate}
                  onChange={setEndDate}
                  KeyboardButtonProps={{ "aria-label": "change date" }}
                />
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  startIcon={<GridSearchIcon />}
                  onClick={() => { getActivityLogs(); }}
                >
                  Filter
                </Button>
              </Grid>
            </Grid>
            <ActivityLogTable activityLogs={logs} handleShowLogs={handleShowLogs} />
          </Box>
        </MuiPickersUtilsProvider>
      )}
    </>
  );
}

export default ActivityLog;
